import React from 'react'

const BloodDonation = () => {
  return (
    <div>Blood Donation</div>
  )
}

export default BloodDonation